/// <amd-module name="Release/Sharedcontributions/Components/PipelineBillingMessageBanner" />
import * as React from "react";

import { IVssLayoutManager, VssComponent, WrappedComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { routeUrl } from "VSS/Platform/Location";

import * as Resources from "Release/Sharedcontributions/Resources";

class PipelineBillingMessageBannerComponent extends VssComponent<{}, {}> {
    public static componentType = "pipelineBillingBanner";

    private concurrentJobsLink: string;

    constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        this.concurrentJobsLink = routeUrl(this.context.pageContext, "ms.vss-build-web.build-release-collection-admin-route-new", { _a: "concurrentJobs" });
    }

    public render(): JSX.Element | null {
        return ((
            <div className={"pipelinebilling-message-banner flex flex-grow fontSizeM info-message"}>
                <FormatComponent className="concurrency-message" format={Resources.ConcurrencyMessageFormat}>
                    {
                        [
                            <a href={Resources.ConcurrencyDocumentLink} target="_blank" rel="noopener noreferrer" key={0}>{Resources.ConcurrencyDocumentLinkName}</a>,
                            <a href={this.concurrentJobsLink} target="_blank" rel="noopener noreferrer" key={1}>{Resources.CocurrentJobLimitsLinkName}</a>
                        ]
                    }
                </FormatComponent>
            </div>
        ));
    }
}

// Register the global banner with the layout manager
VssComponent.register(PipelineBillingMessageBannerComponent.componentType, PipelineBillingMessageBannerComponent);